import React, { useState } from "react";
import { convertStringToArray } from "../../../Utils/utils";
import LightBox from "../../../components/LightBox/LightBox";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { imageUrl } from "../../../constants/constants";

const PhotoGalleryRehab = ({ data }) => {
  const { getText } = useLanguageTranslation();
  const photoArray = convertStringToArray(data?.field_events_image);
  const [visible, setVisible] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const photoGallery = photoArray?.map((url) => {
    return {
      src: imageUrl + url.file_path,
      alt: url.title,
    };
  });

  return (
    <>
      <div className="container">
        <div className="title-sec">
          <h4>{getText("Photo Gallery", "फोटो गैलरी")}</h4>
        </div>
        <div className="row mb-5">
          {photoArray?.length === 0 ? (
            <div className="container">
              <div className="">
                <h4 className="title4">
                  {getText("No photos available", "कोई फ़ोटो उपलब्ध नहीं")}
                </h4>
              </div>
            </div>
          ) : (
            photoArray?.map((item, index) => (
              <div
                key={index}
                className="col-12 col-sm-12 col-md-4 col-lg-4 mvDescWrap photo-detail mb-4"
              >
                <div className="card-sec">
                  <div
                    className="img-sec"
                    onClick={() => {
                      setVisible(true);
                      setActiveIndex(index);
                    }}
                  >
                    <img alt={item.file_path} src={imageUrl + item.file_path} />
                    {item.title && (
                      <div className="desc-sec">
                        <p className="gallery-line-clamp">{item.title}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <LightBox
        visible={visible}
        setVisible={setVisible}
        photoGallery={photoGallery}
        activeIndex={activeIndex}
      />
    </>
  );
};

export default PhotoGalleryRehab;
